import script from "./CardWithdrawForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CardWithdrawForm.vue?vue&type=script&setup=true&lang=js"

import "./CardWithdrawForm.vue?vue&type=style&index=0&id=0c594112&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c594112"]])

export default __exports__